"use strict";
/**
 * Do not edit directly
 * This file is automatically generated
 **/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.icons = void 0;
const react_1 = __importDefault(require("react"));
const interface_arrow_down_1 = require("./components/interface-arrow-down");
const interface_arrow_extend_1 = require("./components/interface-arrow-extend");
const interface_arrow_left_1 = require("./components/interface-arrow-left");
const interface_arrow_minimize_1 = require("./components/interface-arrow-minimize");
const interface_arrow_suffle_1 = require("./components/interface-arrow-suffle");
const interface_arrow_up_1 = require("./components/interface-arrow-up");
exports.icons = {
    "interface-arrow-down": react_1.default.createElement(interface_arrow_down_1.InterfaceArrowDown, null),
    "interface-arrow-extend": react_1.default.createElement(interface_arrow_extend_1.InterfaceArrowExtend, null),
    "interface-arrow-left": react_1.default.createElement(interface_arrow_left_1.InterfaceArrowLeft, null),
    "interface-arrow-minimize": react_1.default.createElement(interface_arrow_minimize_1.InterfaceArrowMinimize, null),
    "interface-arrow-suffle": react_1.default.createElement(interface_arrow_suffle_1.InterfaceArrowSuffle, null),
    "interface-arrow-up": react_1.default.createElement(interface_arrow_up_1.InterfaceArrowUp, null),
};
